<template>
    <div>
        <b-form-group :label="$t('scheduled_tasks.display_mode.mode')">
            <vSelect :options="displayModeOptions" v-model="displayMode" :reduce="option => option.id" label="name"/>
        </b-form-group>
        <b-form-group :label="$t('scheduled_tasks.display_mode.displays')">
            <b-form-checkbox-group :options="displayList" v-model="disp" name="display" stacked />
        </b-form-group>
    </div>
</template>

<script>
import display from '@/store/displays/display'
import vSelect from 'vue-select'

export default {
    name: 'DisplayModeChangeSettings',
    components: {
        vSelect
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        displayModeOptions() {
            return [
                { id: 'BLANKED', name: this.$t('scheduled_tasks.display_mode.blanked') },
                { id: 'NORMAL', name: this.$t('scheduled_tasks.display_mode.normal') },
                { id: 'ONLY_INFOS', name: this.$t('scheduled_tasks.display_mode.only_infos') }
            ];
        },
        displayList: function() {
            var list = [];
            for (var disp of this.$store.state.display.displayList) {
                list.push({ value: disp.id, text: disp.id +' '+ disp.name })
            }
            return list;
        },
        displayMode: {
            get: function() {
                // Tarkistus siltä varalta, että taskilta puuttuu tämä parametri.
                if (this.value.displayMode != undefined && this.value.displayMode[0] != undefined) {
                    // Traveller ymmärtää arvoina sekä nimet että numerot (0 = BLANKED, 1 = NORMAL...)
                    // Toki nimet olisivat suositeltavia, mutta näytöille lähetetään numeroina.
                    if (isNaN(this.value.displayMode[0])) {
                        //console.log('getDisplayMode '+ this.value.displayMode[0]);
                        return this.value.displayMode[0];
                    } else {
                        //console.log('getDisplayMode '+ this.displayModeOptions[parseInt(this.value.displayMode[0])].id);
                        // Numerot mäppäytyvät nimiksi järjestyksessä Display Mode -selectin vaihtoehtojen id:stä.
                        return this.displayModeOptions[parseInt(this.value.displayMode[0])].id;
                    }
                } else {
                    //console.log('getDisplayMode "NORMAL"');
                    return 'NORMAL';
                }
            },
            set: function(newValue) {
                //console.log('setDisplayMode '+ newValue);
                // Parent-komponentille lähetetään kopio value-oliosta, jossa displayMode ylikirjoitetaan uudella arvolla.
                // Parametrien arvot käsitellään JS:ssä ja JSONissa array'nä, joten sijoitetaan newValue uuteen array'hin.
                this.$emit('input', { ...this.value, ['displayMode']: [newValue] });
            }
        },
        disp: {
            get: function() {
                //console.log('getDisp '+ this.value.display);
                return this.value.display
            },
            set: function(newValue) {
                //console.log('setDisp '+ newValue);
                // Display-checkboxit on toteutettu grouppina, jossa valitut arvot ovat jo valmiiksi array'ssä.
                this.$emit('input', { ...this.value, ['display']: newValue });
            }
        }
    },
    created: function() {
        if (!this.$store.state.display) {
            this.$store.registerModule("display", display);
        }
        this.$store.dispatch('display/getDisplayList');
    }
}
</script>

<style lang="scss">
    @import 'vue-select/src/scss/vue-select.scss';
</style>